import router from "@/router";
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    token:null,
    userInfo: {},
    routersInfo: [],
  },
  getters:{
    routersInfo:(state,data)=>{
      state.routersInfo=data
    },
    userInfo:(state,data)=>{
      state.userInfo=data
    },
  },
  mutations:{
    // 存储用户信息
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setRouters(state, data) {
      state.routersInfo = data;
    },
    addToken(state, data) {
      state.token = data;
    },
    logout(state) {
      state.token = null;
      state.userInfo = null;
      state.routersInfo = [];
      sessionStorage.clear();
      localStorage.clear();
      router.replace("/login");
    },
  },
  actions:{
    // 权限路由
    routers({commit},data) {
      commit("setRouters",data)
    },

    // 用户信息
    userInfo({commit},data) {
      commit("setUserInfo",data)
    },

    addRoutes({commit},data) {
      commit("addToken",data)
    }
  },
  modules:{

  }
})